import { render, staticRenderFns } from "./flowShipmentAct.vue?vue&type=template&id=37af4d65&scoped=true&"
import script from "./flowShipmentAct.vue?vue&type=script&lang=js&"
export * from "./flowShipmentAct.vue?vue&type=script&lang=js&"
import style0 from "./flowShipmentAct.vue?vue&type=style&index=0&id=37af4d65&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af4d65",
  null
  
)

export default component.exports